import { useEffect } from "react";
import { getPublicMessage, usePublicI18nOptional } from "../PublicI18nContext";

export const SITE_NAME = "CodeSoft";

export const formatDocumentTitle = (title) =>
  title ? `${title} — ${SITE_NAME}` : SITE_NAME;

export const applyDocumentTitle = (title) => {
  document.title = formatDocumentTitle(title);
};

// WCAG 2.4.2: give each public route a descriptive document title.
// Resolves through the public i18n catalog so the tab title follows the
// active locale.
export default function useDocumentTitle(titleKey, vars) {
  const i18n = usePublicI18nOptional();
  const t = i18n ? i18n.t : (key, tVars) => getPublicMessage("en", key, tVars);
  const title = titleKey ? t(titleKey, vars) : "";

  useEffect(() => {
    applyDocumentTitle(title);
  }, [title]);
}

// For pages whose title arrives as a plain string (e.g. StatusPage) or is
// derived from fetched data (detail pages). A nullish/empty title is a no-op
// so the DocumentTitleManager's route fallback stays until the data arrives.
export function useLiteralDocumentTitle(title) {
  useEffect(() => {
    if (title == null || title === "") return;
    applyDocumentTitle(title);
  }, [title]);
}
